define('TileEllipsis',[
    "jquery",
    "Ellipsis",
    "eventManager"
], function ($, Ellipsis, eventManager) {
    "use strict";

    // Run the ellipsis once the modules have been loaded
    // Since the ModulesLoadedEvent seems to run multiple times 
    // then the setTimeout is needed to make sure the tiles are fully loaded
    // before setting the ellipsis on the tiles
    eventManager.subscribe("ModulesLoadedEvent", function (scope) {
        setTimeout(function () {
            runEllipsis();
        }, 500);
    });

    eventManager.subscribe("RunEllipsisEvent", function (scope) {
        setTimeout(function () { runEllipsis(); }, 500);
    });

    // truncate text in horizontal highlights and featured tile page description
    function runEllipsis() {

        // Research
        $('.mm-search-research-list .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        // global search - news
        $('.ipa-gs-news .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        // global search - research
        $('.ipa-gs-research .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-event-results-wrapper .mm-tile .mm-description').ellipsis({
            lines: 2,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-event-results-wrapper .mm-tile h2').ellipsis({
            lines: 2,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-event-basic-wrapper .mm-tile .mm-description').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });
        $('.ipa-event-basic-wrapper .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-news-basic-wrapper .mm-tile .mm-description').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });
        $('.ipa-news-basic-wrapper .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-properties-results-wrapper .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-gs-properties.list-view .mm-tile h2').ellipsis({
            lines: 2,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-properties-results-wrapper .mm-tile h3').ellipsis({
            lines: 2,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.ipa-gs-search-results .mm-tile .mm-manager-tile-content').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-region-news-results-wrapper .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-region-news-results-wrapper .mm-tile.mm-first-slider-card h2').ellipsis({
            lines: 5,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-region-research-results-wrapper .mm-tile.mm-first-slider-card h2').ellipsis({
            lines: 5,
            ellipClass: 'ellip',
            responsive: true
        });

        $('.mm-region-research-results-wrapper .mm-tile h2').ellipsis({
            lines: 3,
            ellipClass: 'ellip',
            responsive: true
        });

        
    }
});
